import { useTranslate } from "@tolgee/react";
import { useNavigate } from "react-router-dom";
import { ParsedVisit } from "../../types";
import ImportantInfo from "../../assets/important-info.svg?react";
import { PastVisits } from "@frontend/lyng/assets/icons/24/outline";
import { User } from "@frontend/lyng/assets/icons/24/filled";
import { TopButton } from "../../components/core/topButton/TopButton";
import Berries from "../../assets/berries.svg?react";
import { CareHomeFieldsFragment as CareHome } from "../../api/generated/graphql";
import { parseAddress } from "../../utils/addressUtils";
import { useMemo } from "react";
import { Headline, Paragraph } from "@frontend/lyng/typography";

type Props = {
  shift: ParsedVisit | null;
  careHome: CareHome;
};

export const Detail = ({ shift, careHome }: Props) => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  const address = useMemo(() => {
    if (careHome.address) {
      return parseAddress(careHome.address);
    }
    return "";
  }, [careHome.address]);

  return (
    <div className="flex flex-col px-4">
      <div className="flex flex-row pt-4">
        <Berries className="h-16 w-16" />
        <div className="flex grow flex-col gap-1">
          <Headline size="m">{careHome.name}</Headline>
          <Paragraph size="s">{address}</Paragraph>
        </div>
      </div>
      {shift?.importantInformation && (
        <div className="row flex items-center px-4 py-4 bg-primary-900 my-4 rounded-xl">
          <ImportantInfo className="h-8 w-8" />
          <div className="flex grow flex-col pl-4 text-medium text-title">
            <div>{shift.importantInformation}</div>
          </div>
        </div>
      )}
      <div className="mt-4 flex gap-2 z-20">
        <TopButton
          text={t("caregivers.title")}
          icon={<User className=" text-secondary-500" />}
          onClick={() => navigate(`./caregivers/${careHome.id}`)}
        />

        <TopButton
          text={t("pastVisits")}
          icon={<PastVisits className="text-secondary-500" />}
          onClick={() => navigate(`./past-visits/${careHome.id}`)}
        />
      </div>
    </div>
  );
};
